import { Cms } from '@sunrise/types'

export interface NewsItem {
    locationId?: string
    id: number
    type: NewsType
    body: string
    detailUrl?: string
    locationName: string
    locationType: Cms.LocationType
    media?: NewsMedia
    officeId?: number
    originalSource: string
    provider?: string
    published: string
    publisherLogoUrl?: string
    publisherName?: string
    publisherUrl?: string
    textParts: string[]
    time: string
    title: string
    titleImageUrl?: string
    url: string
}

// Keep in sync with the types in https://git.meinestadt.de/ms-dev/core/news/-/blob/master/news-batch/src/main/java/de/meinestadt/news/offices/model/Type.java
export enum NewsType {
    POLICE = 'POLICE',
    FIRE = 'FIRE',
    RSS = 'RSS',
    WARNING = 'WARNING',
}

export interface NewsError {
    error: string
}

export interface NewsImage {
    caption?: string
    id: number
    name?: string
    type?: string
    url: string
    source?: string
}

export interface NewsMedia {
    image?: NewsImage[]
}

export interface NewsResponse {
    content: NewsItem[]
    first: boolean
    // last = some paging information
    last: boolean
    location?: string
    // number = current page (0-based)
    number: number
    radiusExpansion?: string
    radiusExpansionBy?: RadiusExpansionType
    // size = page size
    size: number
    totalElements: number
    totalPages: number
}

export enum RadiusExpansionType {
    RADIUS_IN_METERS = 'RADIUS_IN_METERS',
    NATION = 'NATION',
    FEDERAL_STATE = 'FEDERAL_STATE',
    COUNTY = 'COUNTY',
}

export interface NewsRequestParams {
    page: number
    type?: NewsType[]
    sort?: string[]
    size: number
}

export interface ClientNewsRequestParams extends NewsRequestParams {
    locationId: string
}
